import { useParams } from "react-router-dom";

import { useEvent } from "../../changelog-item-context";
import EntityLink from "../EntityLink";

import EventTitleWrapper, { ActionText } from "./EventTitleWrapper";

import { ActionType, ChangelogEntry, EntityType } from "@/queries";

const DuplicateEventTitle = () => {
  const event = useEvent<ChangelogEntry<ActionType.DUPLICATE>>();
  const { workspaceId } = useParams();

  const blueprintName = event.action_payload?.blueprint_name;
  const blueprintId = event.action_payload?.blueprint_id;
  const columnsDuplicated = event.action_payload?.columns_duplicated;

  const link = blueprintId
    ? `/workspace/${workspaceId}/evaluate/blueprints/${blueprintId}`
    : undefined;

  return (
    <EventTitleWrapper>
      <ActionText>Created from duplicate of</ActionText>
      {blueprintName && <EntityLink type={EntityType.REPORT} name={blueprintName} link={link} />}
      {columnsDuplicated !== undefined && columnsDuplicated > 0 && (
        <ActionText>
          ({columnsDuplicated} column{columnsDuplicated !== 1 ? "s" : ""})
        </ActionText>
      )}
    </EventTitleWrapper>
  );
};

export default DuplicateEventTitle;
